/* ------------------------------------------------------------------
   HEMP LIFE - fills the "Customers also bought" row in the cart drawer
   and handles its one-tap add.

   HISTORY, because it matters. An earlier build of this file did both
   the free-shipping bar and a "Goes well with" row entirely in
   JavaScript against /cart.js. The bar has since moved into
   snippets/cart-drawer.liquid, where Liquid recalculates it from
   cart.total_price on every re-render - it cannot flash a stale figure
   and it needs no script. Only the recommendation row is left here,
   because Shopify populates the `recommendations` object on one route
   and one route only.

   TWO THINGS CARRIED OVER FROM THAT BUILD, both learned the hard way:

   1. PLACEMENT. The row belongs INSIDE the scrolling items region, not
      beside the footer. As a footer sibling it became a fixed ~277px
      block, which on a 683px phone crushed the cart itself to a 94px
      window - the shopper could not see what they had just added. The
      placeholder now lives inside #CartDrawer-CartItems.

   2. INTENT ORDER. Ask for `complementary` first - those are pairings
      a human set up in Search & Discovery - and fall back to `related`,
      which is Shopify's automatic read of order history. Either way the
      "Customers also bought" heading is backed by real data.

   WHY IT RE-SCANS. Dawn replaces the whole of .drawer__inner on every
   cart change, discarding whatever was filled in. The observer notices
   the new empty placeholder and fills it again. The data-hl-filled flag
   is set BEFORE the fetch starts, so the observer firing on our own
   innerHTML write cannot start a loop.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var SECTION = 'hl-cart-recs';

  function request(pid, intent) {
    return fetch(
      '/recommendations/products?section_id=' + SECTION +
      '&limit=10&intent=' + intent +
      '&product_id=' + encodeURIComponent(pid)
    ).then(function (r) { return r.ok ? r.text() : ''; });
  }

  function extract(html) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('.shopify-section');
    return src ? src.innerHTML.trim() : '';
  }

  function fill(el) {
    if (!el || el.getAttribute('data-hl-filled') === '1') return;
    var pid = el.getAttribute('data-product-id');
    if (!pid) return;

    el.setAttribute('data-hl-filled', '1');

    request(pid, 'complementary')
      .then(function (html) {
        var markup = extract(html);
        if (markup) return markup;
        /* Nothing hand-paired for this product - fall back to what the
           order history says. */
        return request(pid, 'related').then(extract);
      })
      .then(function (markup) {
        if (markup) el.innerHTML = markup;
      })
      .catch(function () {
        /* Leave it empty. :empty hides the container, so a failed
           lookup costs the shopper nothing. */
      });
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-hl-xsell]');
    Array.prototype.forEach.call(nodes, fill);
  }

  /* Delegated, so it keeps working after the drawer re-renders. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-hl-xsell-add]') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        btn.removeAttribute('aria-busy');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
      });
  });

  function observe() {
    var host = document.querySelector('cart-drawer');
    if (!host || !window.MutationObserver) return;
    new MutationObserver(scan).observe(host, { childList: true, subtree: true });
  }

  function init() {
    scan();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
